import React, { useState } from "react";
import "./InfluencerHowTablet.css";

const InfluencerHowTablet = ({ steps }) => {
  const [hoveredIndex, setHoveredIndex] = useState(null);

  const rows = [];
  for (let i = 0; i < steps.length; i += 2) {
    const pair = steps.slice(i, i + 2);
    rows.push(pair);
  }

  return (
    <div className="influencerhowtablet-wrapper">
      {rows.map((row, rowIndex) => (
        <div key={rowIndex} className="influencerhowtablet-row">
          {row.map((step, colIndex) => (
            <React.Fragment key={colIndex}>
              <div
                className="influencerhowtablet-step-box"
                onMouseEnter={() =>
                  setHoveredIndex(rowIndex * 2 + colIndex)
                }
                onMouseLeave={() => setHoveredIndex(null)}
              >
                <div className="influencerhowtablet-step-number">
                  {rowIndex * 2 + colIndex + 1}
                </div>
                <div className="influencerhowtablet-step-icon">
                  <div className="influencerhowtablet-icon-box">
                    <img
                      src={
                        hoveredIndex === rowIndex * 2 + colIndex
                          ? step.iconHover
                          : step.icon
                      }
                      alt={step.title}
                    />
                  </div>
                </div>
                <h3>{step.title}</h3>
                <p>{step.text}</p>
              </div>
              {/* Connector only between the two cards in the row */}
              {colIndex === 0 && row.length > 1 && (
                <div className="influencerhowtablet-connector" />
              )}
            </React.Fragment>
          ))}
        </div>
      ))}
    </div>
  );
};

export default InfluencerHowTablet;
